module.exports = __webpack_public_path__ + "static/season-of-the-witch-82d11f0a398842f125f56d373b9585ba.jpg";